import { Component, inject, signal } from '@angular/core';
import { TAGImage } from '../../../models/tagimage';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ApiService } from '../../api.service';
import { ButtonModule } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';
import { SkeletonModule } from "primeng/skeleton";
import { UseHttpImageSourcePipe } from '../../authimage.pipe';

export interface ImageDetailsDialogData {
  image: TAGImage;
  useAuthImagePipe?: boolean;
}

@Component({
  selector: 'app-image-details-dialog',
  imports: [ButtonModule, TranslatePipe, SkeletonModule, UseHttpImageSourcePipe],
  templateUrl: './image-details-dialog.html',
  styleUrl: './image-details-dialog.scss',
})
export class ImageDetailsDialog {
  private api = inject(ApiService);

  thumbLoaded = signal(false);
  fullLoaded = signal(false);

  image = signal<TAGImage>(undefined);

  getImageLink(imageid: string) {
    return this.api.getImageLink(imageid);
  }

  getThumbLink(imageid: string) {
    return this.api.getThumbLink(imageid);
  }

  constructor(
    public dialogRef: DynamicDialogRef<ImageDetailsDialog>,
    public config: DynamicDialogConfig<ImageDetailsDialogData>,
  ) {
    this.image.set(config.data.image);
  }
}
